import dayjs from 'dayjs';

const DEFAULT_SUBJECT_TOKEN = 'conversation-export';
const CONTROL_CHAR_RANGE = `${String.fromCharCode(0)}-${String.fromCharCode(31)}`;
const SANITIZE_FILE_TOKEN_PATTERN = new RegExp(
  `[<>:"/\\\\|?*${CONTROL_CHAR_RANGE}]+`,
  'g',
);

const sanitizeFileToken = (value?: string | null) => {
  const trimmedValue = value?.trim();
  if (!trimmedValue) {
    return '';
  }

  return trimmedValue
    .replace(SANITIZE_FILE_TOKEN_PATTERN, ' ')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
};

export const buildConversationPdfFileName = ({
  friendlyId,
  subject,
  exportedAt,
}: {
  friendlyId?: string | null;
  subject?: string | null;
  exportedAt?: string | Date;
}) => {
  const exportDateToken = dayjs(exportedAt ?? new Date()).format('YYYY-MM-DD');
  const friendlyIdToken = sanitizeFileToken(friendlyId) || 'conversation';
  const subjectToken = sanitizeFileToken(subject) || DEFAULT_SUBJECT_TOKEN;

  return `${friendlyIdToken}-${subjectToken}-${exportDateToken}.pdf`;
};
